import type { Control, FieldPath } from "react-hook-form";
import { z } from "zod";
import TextField from "@mui/material/TextField";
import { Controller } from "react-hook-form";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { createResetPasswordSchema } from "@/schema";
// import useForgotPassword from "@/hooks/use-forgot-password";
import { Box, Typography, Button } from "@mui/material";

const ResetPasswordSchema = createResetPasswordSchema((key: string) => key);

interface ResetPasswordFormFieldViewProps {
  name: FieldPath<z.infer<typeof ResetPasswordSchema>>;
  label: string;
  isLoading: boolean;
  handleResendCode: () => void;
  placeholder: string;
  description?: string;
  inputType?: string;
  formControl: Control<z.infer<typeof ResetPasswordSchema>>;
}

const ResetPasswordFormFieldView: React.FC<ResetPasswordFormFieldViewProps> = ({
  name,
  handleResendCode,
  label,
  placeholder,
  isLoading,
  inputType,
  formControl,
}) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);

  return (
    <Box sx={{ mb: 2 }}>
          {name === "code" ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography variant="subtitle2" fontWeight={600}>
            {label}
          </Typography>
          <Button
            variant="text"
            size="small"
                  onClick={handleResendCode}
            disabled={isLoading}
            sx={{ textTransform: "none", fontWeight: 600 }}
                >
                  {isLoading ? t("status.sending") : t("actions.resendCode")}
          </Button>
        </Box>
          ) : (
        <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1 }}>
          {label}
        </Typography>
          )}
      <Controller
        name={name}
        control={formControl}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            type={inputType || "text"}
              placeholder={placeholder}
            autoComplete={
              name === "newPassword"
                ? "new-password"
                : name === "code"
                ? "one-time-code"
                : "off"
            }
            fullWidth
            variant="outlined"
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            InputLabelProps={{ shrink: false }}
            sx={{ mt: 0 }}
          />
      )}
    />
    </Box>
  );
};

export default ResetPasswordFormFieldView;
